<template>
  <div>
    <div
      v-for="(option, index) in options" :key="index"
      class="my-2 ml-1">
      <b-row>
        <b-col class="" sm="12">
          <b-input-group class="flex flexMiddle">
            <span
              v-show="!uploadedFileName && (!optionData(option.id).dbFileName || optionData(option.id).do_delete_file)"
              class="mb-2 fileName">ファイル名：ファイルが選択されていません</span>
            <span
              class="mb-2 fileName"
              v-show="uploadedFileName">
              ファイル名：{{uploadedFileName}}
            </span>
            <span
              class="mb-2 fileName"
              @click="downloadFormFile(fieldId, option.id, optionData(option.id).dbFileName)"
              v-show="!uploadedFileName && optionData(option.id).dbFileName && !optionData(option.id).do_delete_file">
              ファイル名：
              <b-link
                class="mb-1">{{optionData(option.id).dbFileName}}</b-link>
            </span>
            <!-- No.12: 削除アイコン（追加資料フォームのみ）。新規選択ファイル or 既存DBファイル(未削除)のとき表示。押下で「未選択」に戻す。メール送信画面の添付削除と同じ共通アイコン（○×）に統一 -->
            <img
              v-if="canDeleteFile && writable && (uploadedFileName || (optionData(option.id).dbFileName && !optionData(option.id).do_delete_file))"
              src="@/assets/svg/close_small.svg"
              class="tdDeleteBtn ml-3 mb-2"
              @click="onClickDelete(option.id)">
          </b-input-group>

          <b-input-group v-if="writable">
            <b-input-group-prepend
              class="mr-1 flex flexMiddle">
              {{option.label}}
              {{option.prefix}}
            </b-input-group-prepend>
            <div
              @dragover.prevent="toggleDrag($event, true)"
              @dragleave.prevent="toggleDrag($event, false)"
              @drop.prevent="onDrop($event, option.id)"
              :class="[
                isDragging ? 'is-dragging' : '',
                optionData(option.id).errMessages.length > 0 ? 'errItem' : '',
                'drop', 'flex', 'flexMiddle', 'flexCenter'
              ]">
              <span>
                <span
                  :class="[isDragging ? 'is-dragging' : '',
                    'dragText',
                    'fw-6']">ここにファイルをドラッグ＆ドロップ または</span>
                <label
                  :for="`file_${fieldId}`"
                  class="fileText fw-6 selectFile">［ ファイルを選択 ］</label>
                <p
                  :class="[isDragging ? 'is-dragging' : '', 'fileNotation', 'mb-0']">
                  （ファイルを再アップロードした場合アップロード済みのファイルは上書きされます）
                  </p>
                <input type="file" style="display:none;"
                  :id="`file_${fieldId}`"
                  @change="upload($event, option.id)"
                >
              </span>
            </div>

            <b-input-group-append
              class="ml-1 flex flexMiddle">
              {{option.suffix}}
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="ml-1">
        <p class="error my-1"
          v-for="(msg, index) in optionData(option.id).errMessages" :key="index">
          {{msg}}
        </p>
      </b-row>

    </div>
  </div>
</template>
<script>

export default {
  name: 'PartsApplicationFile',
  props: {
    fieldId: { type: Number },
    notice: {},
    options: {
      type: Array,
      default: () => {
        return [
          {
            id: '',
            label: '',
            // input_type: '',
            prefix: '',
            suffix: '',
            parent_option_id: null,
            parent_choice_id: null,
            view_template: 1,
          },
        ];
      },
    },
    writable: { type: Boolean, default: false },
    // No.12: 追加資料フォームのみ削除ボタンを表示するためのフラグ
    canDeleteFile: { type: Boolean, default: false },
    downloadFormFile: { type: Function },
  },
  data() {
    return {
      doDeleteUploadedFile: false,
      uploadedFileName: '',
      isDragging: false,
    };
  },
  methods: {
    upload(event, optionId) {
      if (event.target.files.length === 0) {
        return;
      }
      const file = event.target.files[0];
      this.uploadedFileName = file.name;
      this.kickSetFile(file, optionId);
      // No.12: 同じファイルを選び直しても @change が発火するよう input をクリア
      const fileInput = event.target;
      fileInput.value = '';
    },
    kickSetFile(value, optionId) {
      const param = {
        field_id: this.fieldId,
        option_id: optionId,
        answer_no: 1, // ファイルは当面１つ固定
        file: value,
      };
      this.$emit('kickSetFile', param);
    },
    toggleDoDeleteDbFile(input) {
      // No.12: ストアの mutation 名は toggleDoDeleteFile（旧 commit 名の不一致を修正）
      this.$store.commit('gasApplicationInput/toggleDoDeleteFile', input);
    },
    // No.12: 削除ボタン押下。新規選択ファイルは取消、既存DBファイルは削除指定（保存で実削除）
    onClickDelete(optionId) {
      if (this.uploadedFileName) {
        this.uploadedFileName = '';
        this.$store.commit('gasApplicationInput/clearFile', {
          field_id: this.fieldId,
          option_id: optionId,
          answer_no: 1,
        });
      } else {
        this.toggleDoDeleteDbFile(this.optionData(optionId));
      }
    },
    toggleDrag(event, isDragging) {
      this.isDragging = isDragging;
    },
    onDrop(event, optionId) {
      this.isDragging = false;
      const fileList = event.target.files ? event.target.files : event.dataTransfer.files;
      // ファイルが無い時処理を中止
      if (fileList.length === 0) {
        return false;
      }
      const file = fileList[0];
      this.kickSetFile(file, optionId);
      this.uploadedFileName = file.name;
      return true;
    },
    deleteUploadedFile(optionId) {
      const value = {};
      this.kickSetFile(value, optionId);
    },
  },
  computed: {
    optionData() {
      const self = this;
      return (optionId) => {
        const { inputs } = this.$store.state.gasApplicationInput;
        const target = inputs.find((input) => {
          const sameField = input.field_id === self.fieldId;
          const sameOption = input.option_id === optionId;
          const sameAnswerNo = input.answer_no === 1;
          return sameField && sameOption && sameAnswerNo;
        });
        return target;
      };
    },
    isCms() {
      return this.$store.state.gasApplicationForm.isCms;
    },
  },
};
</script>

<style scoped>
  .error {
    font-size: 80%;
    color: #dc3545;
  }

  .drop {
    height: 120px;
    width: 100%;
    background-color: #F3F3F3;
    border-color: #CCC;
    border-style: dashed;
    border-radius: 10px;
    border-width: 1px;
  }

  .dragText {
    color: #BBB;
  }

  .fileText {
    color: #0A8EA7;
  }

  .fileNotation {
    color: #BBB;
  }

  .is-dragging.drop {
    background-color: #E6E6E6;
    border-color: #6E6E6E;
  }

  .is-dragging {
    color: #6E6E6E;
  }

  .selectFile {
    cursor: pointer;
  }
  .selectFile:hover {
    text-decoration: underline;
  }

  .fileName {
    margin-top: 16px;
  }

  .errItem {
    border:solid 1px #dc3545 !important;
  }
</style>
